import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "environments/environment";
import { WorkflowResponse } from "app/core/models/workflow-response";

@Injectable()
export class WorkflowService {

  constructor(private readonly _httpClient: HttpClient) { }

  public getWorkflows(filter: string, sortDirection: 'asc' | 'desc'| '', sortField: string, 
                      pageIndex: number, pageSize: number, activeFilters: Object[]): Observable<WorkflowResponse> {
    
    let allStringFilterAux = [];
    activeFilters.forEach((item, index) => {
      if (item['value'] != null && item['value'] != '') {
        let stringFilterAux = [item['id'],item['value']];
        allStringFilterAux.push(stringFilterAux.join('::'));
      }
    });

    let queryFilter = allStringFilterAux.join('--');

    
    let params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '')
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/workflows`, {
      params: params
      }).pipe(
          
          map(res =>  <WorkflowResponse>res)
      );
  }

  
  getWorkflowActions(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/workflows/actions`);
  }

  getWorkflowStatus(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/workflows/status`);
  }

  getWorkflowSource(): Observable < any > {
    return this._httpClient.get(`${environment.apiUrl}/workflows/source`);
}

  getWorkflowsList(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/workflows`);
  }

  getWorkflow(id: string): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/workflows/${id}`);
  }

  createWorkflow(workflow: any): Observable < any > {
      return this._httpClient.post(`${environment.apiUrl}/workflows`, workflow);
  }

  editWorkflow(workflow: any, id: string): Observable < any > {
      return this._httpClient.put(`${environment.apiUrl}/workflows/${id}`, workflow);
  }

  deleteWorkflow(id: string): Observable < any > {
      return this._httpClient.delete(`${environment.apiUrl}/workflows/${id}`);
  }
  
}
